import Text from 'components/_UI/Text';
import React, { useMemo } from 'react'
import { BarChart2 } from 'lucide-react';
import styled from 'styled-components';
import colors from 'theme/colors';
import VendasTab from 'modules/dashboard/statistics/tabs/VendasTab';

/* Períodos que /dashboard/statistics/* aceita. O filtro do financeiro é mais
   largo (tem 90d e intervalo livre), então o que não existe lá cai em 30d em
   vez de estourar um 422. */
const SUPPORTED_PERIODS = ['today', 'yesterday', '7d', '14d', '30d', 'all'];
const FALLBACK_PERIOD = '30d';
const MAX_CUSTOM_RANGE_DAYS = 30;

function daysBetween(start, end) {
    return Math.abs((new Date(end) - new Date(start)) / (1000 * 60 * 60 * 24));
}

export function toStatisticsParams(filters) {
    if (filters?.start_date && filters?.end_date) {
        return daysBetween(filters.start_date, filters.end_date) <= MAX_CUSTOM_RANGE_DAYS
            ? { start_date: filters.start_date, end_date: filters.end_date }
            : { period: FALLBACK_PERIOD };
    }

    return SUPPORTED_PERIODS.includes(filters?.period)
        ? { period: filters.period }
        : { period: FALLBACK_PERIOD };
}

export default function FinancialAnalysis({ filters = {} }) {
    const periodParams = useMemo(() => toStatisticsParams(filters), [JSON.stringify(filters)]);

    const isAdjustedPeriod =
        (filters?.period && !SUPPORTED_PERIODS.includes(filters.period)) ||
        (filters?.start_date && daysBetween(filters.start_date, filters.end_date) > MAX_CUSTOM_RANGE_DAYS);

    return (
        <Container>
            <SectionHeader>
                <SectionIcon>
                    <BarChart2 size={18} color={colors.occasionalPurple} />
                </SectionIcon>
                <HeaderContent>
                    <Text type='bold' color={colors.nightDark} paddingBottom={0}>
                        Análises
                    </Text>
                    <Text name='small' color={colors.night} paddingBottom={0}>
                        Ticket médio, estornos e conversão, comparados com o período anterior
                    </Text>
                </HeaderContent>
            </SectionHeader>

            {isAdjustedPeriod && (
                <PeriodNotice>
                    As análises cobrem no máximo 30 dias — este bloco está mostrando
                    os últimos 30 dias, não o período selecionado acima.
                </PeriodNotice>
            )}

            {filters?.event && (
                <PeriodNotice>
                    As análises ainda não separam por evento: os números abaixo são
                    de todos os seus eventos, mesmo com um evento filtrado acima.
                </PeriodNotice>
            )}

            <VendasTab periodParams={periodParams} />
        </Container>
    )
}

const Container = styled.div`
    background: ${colors.neutralLight};
    border: 1px solid ${colors.neutralDark};
    border-radius: 12px;
    padding: 20px;
    margin-top: 10px;
`;

const SectionHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
`;

const SectionIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: #F3EAFF;
    flex-shrink: 0;
`;

const HeaderContent = styled.div`
    flex: 1;
`;

const PeriodNotice = styled.p`
    margin: 0 0 16px;
    padding: 10px 14px;
    border-radius: 10px;
    border: 1px solid rgba(255, 145, 35, 0.3);
    background: rgba(255, 145, 35, 0.08);
    color: #a35400;
    font-size: 12px;
    line-height: 1.5;
`;
